module.exports = __webpack_public_path__ + "img/2.77f20b8f.png";